// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operators-emails-input input {
  min-height: 156px;
}
.operators-emails-input input::placeholder {
  position: relative;
  top: -45px;
}

.validate-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.radio-validate-container {
  width: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.radio-validate-container .button {
  position: relative;
  right: 100px;
}
.radio-validate-container .radio-container {
  display: flex;
  width: 100%;
}
.radio-validate-container .radio-container section {
  width: 50%;
  margin-right: 1rem;
}
.radio-validate-container .radio-container section div {
  display: flex;
}
.radio-validate-container .radio-container section p {
  font-size: 16px;
  font-weight: bold;
  position: relative;
  top: 8px;
  margin-right: 12px;
}

.tabs__list {
  font-size: 18px;
  color: gray;
  font-weight: 600;
  border-bottom: 0.8px solid gray;
}
.tabs__list .react-tabs__tab--selected {
  color: #0abf53;
}

.input-field {
  display: flex;
  justify-content: flex-start;
}
.input-field__label {
  width: fit-content;
}

.inputs-wrapper {
  display: flex;
  justify-content: space-between;
}
.inputs-wrapper__inputs {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}
.inputs-wrapper__inputs small {
  font-size: 12px;
  color: red;
  text-align: left;
}

.buttons-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.buttons-wrapper .button--primary,
.buttons-wrapper .button--simple,
.buttons-wrapper .button--error {
  width: 180px;
  height: 56px;
}
.buttons-wrapper .button--primary {
  margin-left: 16px;
}

.form-inputs-container {
  display: flex;
  justify-content: center;
}
.form-inputs-container .input-field {
  width: 100%;
}
.form-inputs-container .input-field:last-of-type {
  margin-left: 20px;
}
.form-inputs-container .dropdown-container {
  width: 100%;
  margin-bottom: 20px;
}
.form-inputs-container .dropdown-container:first-of-type {
  margin-right: 20px;
}
.form-inputs-container .dropdown-container .basic-single {
  width: 100%;
}
.form-inputs-container .dropdown-container .select__indicators,
.form-inputs-container .dropdown-container .select__value-container.select__value-container--is-multi {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 54px !important;
}
.form-inputs-container .dropdown-container .select__menu {
  position: absolute;
  top: 45px !important;
}

.notificationUrl {
  padding: 0 20px 0 10px;
}

#credentials {
  display: flex;
  justify-content: center;
}
#credentials span {
  width: 100%;
}
#credentials span:last-of-type {
  margin-left: 20px;
}
#credentials h3 {
  font-weight: 600;
}

#notifications h3 {
  font-weight: 600;
  margin-bottom: 20px;
}
#notifications .react-tabs__tab--selected {
  color: #0abf53;
}

#management button {
  margin: 0 10px;
}

.big-plus-button {
  font-size: 24px;
}

.toggle-button-wrapper {
  display: flex;
  justify-content: space-between;
}

.toggle-channel-left, .toggle-channel-right {
  flex: 1 1;
}

.toggle-channel-left {
  text-align: left;
}

.toggle-channel-right {
  text-align: left;
}

.dropdown-payout {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/FirstMarketplaceForm/FirstMarketplaceForm.scss"],"names":[],"mappings":"AAGE;EACE,iBAAA;AADJ;AAEI;EACE,kBAAA;EACA,UAAA;AAAN;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AADF;;AAIA;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAEE;EACE,kBAAA;EACA,YAAA;AAAJ;AAEE;EACE,aAAA;EACA,WAAA;AAAJ;AACI;EACE,UAAA;EACA,kBAAA;AACN;AAAM;EACE,aAAA;AAER;AAAM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;AAER;;AAGA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EAIA,+BAAA;AAHF;AAAE;EACE,cAAA;AAEJ;;AAGA;EACE,aAAA;EACA,2BAAA;AAAF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,aAAA;EACA,8BAAA;AAAF;AACE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AAAI;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAEN;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AACE;;;EAGE,YAAA;EACA,YAAA;AACJ;AACE;EACE,iBAAA;AACJ;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AAAE;EACE,WAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;AAGN;AADI;EACE,WAAA;AAGN;AADI;;EAEE,yBAAA;EACA,4BAAA;EACA,uBAAA;AAGN;AAAI;EACE,kBAAA;EACA,oBAAA;AAEN;;AAEA;EACE,sBAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;AAEF;AADE;EACE,WAAA;AAGJ;AAFI;EACE,iBAAA;AAIN;AADE;EACE,gBAAA;AAGJ;;AACE;EACE,gBAAA;EACA,mBAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;;AAEE;EACE,cAAA;AACJ;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":["@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);\n\n.operators-emails-input {\n  input {\n    min-height: 156px;\n    &::placeholder {\n      position: relative;\n      top: -45px;\n    }\n  }\n}\n.validate-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.radio-validate-container {\n  width: 100;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .button {\n    position: relative;\n    right: 100px;\n  }\n  .radio-container {\n    display: flex;\n    width: 100%;\n    section {\n      width: 50%;\n      margin-right: 1rem;\n      div {\n        display: flex;\n      }\n      p {\n        font-size: 16px;\n        font-weight: bold;\n        position: relative;\n        top: 8px;\n        margin-right: 12px;\n      }\n    }\n  }\n}\n.tabs__list {\n  font-size: 18px;\n  color: gray;\n  font-weight: 600;\n  .react-tabs__tab--selected {\n    color: #0abf53;\n  }\n  border-bottom: 0.8px solid gray;\n}\n\n.input-field {\n  display: flex;\n  justify-content: flex-start;\n  &__label {\n    width: fit-content;\n  }\n}\n\n.inputs-wrapper {\n  display: flex;\n  justify-content: space-between;\n  &__inputs {\n    display: flex;\n    flex-direction: column;\n    margin-top: 25px;\n    small {\n      font-size: 12px;\n      color: red;\n      text-align: left;\n    }\n  }\n}\n\n.buttons-wrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 45px;\n  .button--primary,\n  .button--simple,\n  .button--error {\n    width: 180px;\n    height: 56px;\n  }\n  .button--primary {\n    margin-left: 16px;\n  }\n}\n.form-inputs-container {\n  display: flex;\n  justify-content: center;\n  .input-field {\n    width: 100%;\n    &:last-of-type {\n      margin-left: 20px;\n    }\n  }\n  .dropdown-container {\n    width: 100%;\n    margin-bottom: 20px;\n    &:first-of-type {\n      margin-right: 20px;\n    }\n    .basic-single {\n      width: 100%;\n    }\n    .select__indicators,\n    .select__value-container.select__value-container--is-multi {\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      height: 54px !important;\n    }\n  \n    .select__menu {\n      position: absolute;\n      top: 45px !important;\n    }\n  }\n}\n.notificationUrl {\n  padding: 0 20px 0 10px;\n}\n#credentials {\n  display: flex;\n  justify-content: center;\n  span {\n    width: 100%;\n    &:last-of-type {\n      margin-left: 20px;\n    }\n  }\n  h3 {\n    font-weight: 600;\n  }\n}\n#notifications {\n  h3 {\n    font-weight: 600;\n    margin-bottom: 20px;\n  }\n  .react-tabs__tab--selected {\n    color: #0abf53;\n  }\n}\n#management {\n  button {\n    margin: 0 10px;\n  }\n}\n.big-plus-button {\n  font-size: 24px;\n}\n\n.toggle-button-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.toggle-channel-left, .toggle-channel-right {\n  flex: 1;\n}\n\n.toggle-channel-left {\n  text-align: left;\n}\n\n.toggle-channel-right {\n  text-align: left;\n}\n\n.dropdown-payout {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
